import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { environment } from "../../../environments/environment";
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as _ from 'underscore';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { OpenaiService } from 'src/app/openai/openai.service';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import cjson from 'compressed-json';


declare var google;

@Component({
    selector: 'app-overview-tab',
    templateUrl: './overview-tab.component.html',
    styleUrls: ['./overview-tab.component.scss'],
    standalone: false
})
export class OverviewTabComponent implements OnInit {

  companyDetails: any = {};
  topLocations: any[] = [];
  companiesGaining: any[] = [];
  companiesLosing: any[] = [];
  school: any[] = [];
  fieldOfStudy: any[] = [];
  skills: any[] = [];
  titles: any[] = [];
  currentCompanyName: any;
  dataSourceWorkCountry: any = [];
  gross_additions_by_month: number = 0;
  hireDepartureTalentMovement: any = {};
  showSchoolLoader: boolean = true;
  alternatecompanyNames: any[] = []
  totalresultscount: any
  medianTanuresCount: any
  changedjobscount: any
  top_next_employers_by_role_images: any;

  abs(params: number) {
    return Math.abs(params);
  }
  subscriptions: Array<Subscription> = [];
  locationemptystate: Boolean = false;
  companyemptystate: Boolean = false;
  companylosingemptystate: Boolean = false;
  schoolemptystate: Boolean = false;
  fieldofstudyemptystate: Boolean = false;
  skillemptystate: Boolean = false;
  titlesemptystate: Boolean = false;
  companyinsightsFilter: any = {};
  medianTenureLoader: Boolean = false;

  /**
   * Object of Hire and Attrition
   * Keys of Recent Hires and Recent Attrition
   * Contains count and percentage
   */
  hiresAndAttritionObj: any = {};
  primaryCompanyInformation: any = {};

  overviewDataForAISummary: {} = {};
  insightsExportSubscription: Subscription = null;
  combinedAggregates: any = {};
  combinedSkills: any = {};
  combinedJobtitle: any = {};
  combinedLocation: any = {};
  jobDemandCount: any;
  jobPostsLoader: boolean = false;
  sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  sliderPayload:any
  hasJobListingAccess:any

  filterData: any;
  companyaiSuggestions: any = {};

  constructor(
    private fusionChartService: FusionChartsService,
    private router: Router,
    private route: ActivatedRoute,
    private personSearchService: PersonSearchService,
    private companyInsightsService: CompanyInsightsService,
    private location: Location,
    private localStorageService: LocalStorageService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService,
    private reqObjectHandlerService: AggReqObjectHandlerService,
    private aggReqObjHandler: AggReqObjectHandlerService,
    private talentInsightsService: TalentInsightsService,
    private openaiService: OpenaiService
  ) { }

  ngOnInit(): void {
    this.setCompanyDetails();
        this.getJobtitleSkillSuggestions();
    this.setGrossAdditionsByMonth();
  // overview-tab.component.ts
const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
  // The emitted object is just an event descriptor — use it for routing only
  const eventInfo = _methodDetails;

  // The actual current filter-panel state lives in the getter
  this.filterData = this.filterDataHandlerService.fetchFilterData;

  if (eventInfo?.filterType == 'skills' || eventInfo?.filterType == 'jobtitle' || eventInfo?.filterType == 'keyword'
      || eventInfo?.filterType == 'pastjobtitle' || eventInfo?.filterType == 'search' || eventInfo?.filterType == 'allfilters') {
    this.getJobtitleSkillSuggestions();
  } else if (eventInfo?.filterType == 'location' || eventInfo?.filterType == 'industry' || eventInfo?.filterType == 'company'
      || eventInfo?.filterType == 'seniority' || eventInfo?.filterType == 'function' || eventInfo?.filterType == 'functions'
      || eventInfo?.filterType == 'locationRange') {
    this.fetchPageData();
  } else {
    this.fetchPageData();
  }
});
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyInsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
    this.hasJobListingAccess = this.localStorageService.getItem('hasjoblistingaccess')
  }

  private setCompanyDetails() {
    this.companyDetails = this.companyInsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  private fetchPageData(companyDetails?: any) {
    if (companyDetails)
      this.companyDetails = companyDetails;
    this.getTopLocations();
    this.getSchool();
    this.getFieldOfStudy();
    this.getSkills();
    this.getTitles();
    // this.getchangedjobcount();
    this.getcompanywinningTalentFrom();
    this.getcompanylosingtalentto();
    this.getGrowthRateAttrtionRateData();
    this.getMedianTanureCount();

    this.getJobDemandCount()
  }

  private setGrossAdditionsByMonth() {
    if (this.companyDetails?.gross_additions_by_month) {
      const movementCompanies: [string, number][] = Object.entries(this.companyDetails.gross_additions_by_month);
      movementCompanies.forEach(([dateRaw, count]) => {
        const date = dateRaw + '-01';
        if (this.hireDepartureTalentMovement[date]) {
          this.hireDepartureTalentMovement[date].hireTalent = count;
          this.hireDepartureTalentMovement[date].totalTalent = this.hireDepartureTalentMovement[date]?.departureTalent + count;
        } else {
          this.hireDepartureTalentMovement[date] = {
            hireTalent: count,
            label: Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(new Date(date)),
            order: parseInt(date.replace(/-/g, ''), 10)
          };
        }
      });
    }
    this.gross_additions_by_month = Object.values(this.hireDepartureTalentMovement).sort((a: any, b: any) => a.order - b.order).slice(-12).map((x: any) => x.hireTalent).reduce((a, c) => a + c, 0);
  }

  getGrowthRateAttrtionRateData() {
    let request: AggregationRequest = new TIAggRequest();
    this.aggReqObjectHandlerService.setShareRequestObject(request);
    request = this.aggService.getRequestWithFilters();
    request.companyids = [this.companyDetails.id];
    request.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(request);
    const data = {
      ...request,
      companies: this.alternatecompanyNames,

    };

    this.hiresAndAttritionObj = {};

    //Get company Attrition data
    this.personSearchService.getCompanyAttrition(data).subscribe((res: any) => {
      if (res && res.data) {
        const recentAttrtion = {
          "increaseRate": res.data?.increaseRate,
          "previousYearCount": res.data?.previousYearCount,
          "currentYearCount": res.data?.currentYearCount,
          "type": res.data?.type
        }
        this.hiresAndAttritionObj['recentAttrtion'] = recentAttrtion
      }
    })

    //Get company Growth Data
    this.personSearchService.getCompanyGrowth(data).subscribe((res: any) => {
      if (res && res.data) {
        const recentGrowth = {
          "increaseRate": res.data?.increaseRate,
          "previousYearCount": res.data?.previousYearCount,
          "currentYearCount": res.data?.currentYearCount,
          "type": res.data?.type
        }
        this.hiresAndAttritionObj['recentGrowth'] = recentGrowth;
      }
    })
  }

  getTopLocations() {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "location";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.topLocations = response.data.aggregations.location.slice(0, 5);
      this.locationemptystate = true;
      this.totalresultscount = response.data.totalresultscount;
      const CharForworkCountry = [];
      CharForworkCountry.push(['Location', 'Professional count'])
      this.topLocations.slice(0, 10).forEach(x => {
        const dataObj = [`${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`, x.doc_count];
        CharForworkCountry.push(dataObj);
      });
      this.dataSourceWorkCountry = CharForworkCountry;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        locations: this.topLocations,

      }
      setTimeout(() => {
        this.loadGoogleMap();
      });
    });
  }

  getCompaniesGaining() {
    this.companiesGaining = Object.entries(this.companyDetails.top_next_employers_by_role.all).map(([key, value]) => ({ key, doc_count: value })).slice(0, 5);
    this.getCompaniesGainingLogo();

  }

  getCompaniesLosing() {
    this.companiesLosing = Object.entries(this.companyDetails.top_previous_employers_by_role.all).map(([key, value]) => ({ key, doc_count: value })).slice(0, 5);
    this.getCompaniesLosingLogo();
  }

  getSchool() {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "school";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.school = response.data.aggregations.school.slice(0, 5);
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        schools: this.school
      }
      this.showSchoolLoader = false;
      this.schoolemptystate = true;
    });
  }

  getFieldOfStudy() {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "fieldofstudy";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.fieldOfStudy = response.data.aggregations.fieldofstudy;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        fieldofstudy: this.fieldOfStudy
      }
      this.fieldofstudyemptystate = true;
    });

  }

  getSkills() {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "skills";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.skills = response.data.aggregations.skills.slice(0, 5);
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        skills: this.skills
      }
      this.skillemptystate = true;
    });
  }

  getTitles() {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "jobtitle";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.titles = response.data.aggregations.jobtitle.slice(0, 5);
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        titles: this.titles
      }
      this.titlesemptystate = true;
    });
  }


  loadGoogleMap() {
    function drawMarkersMap() {
      var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
      var options = {
        region: 'world',
        displayMode: 'markers',
        colorAxis: { colors: this.fusionChartService.LOCATION_COLOR_PALETTE }
      };
      const container = document.getElementById('workCountryChart');
      var chart = new google.visualization.GeoChart(container);
      chart.draw(data, options);
    }

    //  if (this.isInsightsActive) {
    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
    //  }
  }

  getchangedjobcount() {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "changedjobs";
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      if (response.status == "success") {
        this.changedjobscount = response.data.aggregations && response.data.aggregations.changedjobs && response.data.aggregations.changedjobs.doc_count ? response.data.aggregations.changedjobs.doc_count : 0;
      }
    });
  }

  getMedianTanureCount() {
    this.medianTenureLoader = true;
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "total_tenure_median";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((res: any) => {
      if (res.data && res.data.aggregations && res.data.aggregations.total_tenure_median) {
        this.medianTenureLoader = false;
        this.medianTanuresCount = res.data && res.data.aggregations && res.data.aggregations.total_tenure_median && res.data.aggregations.total_tenure_median.value;
      }
    });

  }

  returnSpanTag(text) {
    let spanTag = document.createElement("span");
    spanTag.className = 'median-tenure-text-size';
    spanTag.innerHTML = text
    return spanTag;
  }

  getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (tenure == null) {
      return 0;
    } else if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
        return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }

  getcompanywinningTalentFrom() {
    this.reqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    requestObject.resultsize = 7;
    requestObject.startindex = 0;
    requestObject.aggregatescount = 5;
    requestObject.companies = this.alternatecompanyNames;
    requestObject.functiontype = 'Current';
    requestObject.companyids = [this.companyDetails.id]; // not in use for now, will use it later
    this.companyInsightsService.getcompanywinningTalentFrom(requestObject).subscribe((response) => {
      if (response.status == "success") {
        this.companiesGaining = response.aggregations.winningtalentfromcompany;
        this.overviewDataForAISummary = {
          ...this.overviewDataForAISummary,
          winningtalentfromcompany: this.companiesGaining
        }
        this.companyemptystate = true;
        this.getCompaniesGainingLogo();
      }
    });
  }

  getcompanylosingtalentto() {
    this.reqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    requestObject.resultsize = 7;
    requestObject.startindex = 0;
    requestObject.aggregatescount = 5;
    requestObject.companies = this.alternatecompanyNames;
    requestObject.companyids = [this.companyDetails.id]; // not in use for now, will user it later
    requestObject.functiontype = 'Current';

    this.companyInsightsService.getcompanylosingtalentto(requestObject).subscribe((response) => {
      if (response.status == "success") {
        this.companiesLosing = response.aggregations.losingtalenttocompany;
        this.companylosingemptystate = true;
        this.getCompaniesLosingLogo();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getCompaniesGainingLogo() {

    if (this.companiesGaining) {

      let companyLogoPayload = this.companiesGaining.map(item => {
        if (item.id || item.key) {
          return {
            ...(item?.id && { id: item.id }),
            ...(item?.key && { name: item.key })
          }
        }
      }).filter(Boolean);

      companyLogoPayload?.length &&
        this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
          if (res && res.status == "success") {
            const resultName = res.data
            resultName.forEach(obj => {
              const matchingObj = this.companiesGaining.find((item) => item.key === obj.key);
              if (matchingObj) {
                let companyLogo = obj.companylogo
                matchingObj.companylogo = companyLogo;
                matchingObj.website = obj.website;
              }
            });
          }
        });

    }
  }


  getCompaniesLosingLogo() {
    if (this.companiesLosing) {
      let companyLogoPayload = [];
      this.companiesLosing.map(item => {
        if (item?.id || item?.key) {
          companyLogoPayload.push({
            ...(item?.id && { id: item.id }),
            ...(item?.key && { name: item.key })
          });
        }
      });
      companyLogoPayload?.length &&
        this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
          if (res && res.status == "success") {
            const resultName = res.data
            resultName.forEach(obj => {
              const matchingObj = this.companiesLosing.find((item) => item.key === obj.key);
              if (matchingObj) {
                let companyLogo = obj.companylogo
                matchingObj.companylogo = companyLogo;
                matchingObj.website = obj.website;
              }
            });
          }
        });

    }

  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
handelRedirection(type: string, key: string) {
  const redirectFilters: Partial<FilterParams> = {
    // Company context — always present
    companyid: this.companyDetails?.id,
    companyname: this.currentCompanyName,
    alternativecompanynames: this.alternatecompanyNames,

    // Read-only snapshot of the overview tab's OWN filter panel (person-search-filter
    // sidebar). Nested so it can never collide with the listing page's normal filters.
    insightsFilterData: this.filterData,
  };

  // The ONE thing that actually scopes the search — the clicked metric
  switch (type) {
    case 'winningtalent':
      redirectFilters['mandatorycompanies'] = [key];
      redirectFilters['recentcompanyhires'] = true;
      break;
    case 'losingtalent':
      redirectFilters['mandatorycompanies'] = [key];
      redirectFilters['recentcompanyattrition'] = true;
      break;
    case 'recentGrowth':
      redirectFilters['recentcompanyhires'] = true;
      break;
    case 'recentAttrtion':
      redirectFilters['lastjobcompanyids'] = [this.companyDetails.id];
      redirectFilters['recentcompanyattrition'] = true;
      break;
    case 'location':      redirectFilters['mandatorylocations'] = [key]; break;
    case 'industry':      redirectFilters['mandatoryindustries'] = [key]; break;
    case 'school':        redirectFilters['mandatoryschools'] = [key]; break;
    case 'fieldofstudy':  redirectFilters['mandatoryeducationalmajors'] = [key]; break;
    case 'skills':        redirectFilters['insightsmandatoryskills'] = [key]; break;
    case 'jobtitle':      redirectFilters['mandatoryjobtitles'] = [key]; break;
  }


  const uniqueKey = this.hashService.generateUniqueHash();
  localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

  const url = `/candidate-list?type=search&redirectSource=company-insights&key=${uniqueKey}`;
  window.open(url, '_blank');
}


  getCompanyInfo(companyname) {
    let companyData = [];
    if (companyname) {
      companyData = [{
        name: companyname
      }];
    }
    companyData?.length &&
      this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
        if (res.status == 'success' && res.data) {
          let companyDetails = res.data[0]
          this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
          this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
          this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
          this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
          this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
          this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['id'] = companyDetails.id
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['key_id'] = companyDetails.id
          this.primaryCompanyInformation['twitter_url'] = companyDetails.twitter_url ? companyDetails.twitter_url : null;
          this.primaryCompanyInformation['github_url'] = companyDetails.github_url ? companyDetails.github_url : null;
          this.primaryCompanyInformation['facebook_url'] = companyDetails.facebook_url ? companyDetails.facebook_url : null;

        }
      });
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if (requestData?.data?.currentTab !== 'overview') return;

    const payloadForInsightsExport: ExportPayload = {
      tab: 'overview',
      companydetails: this.companyDetails,
      totalresultcount: this.totalresultscount,
      recentGrowth: this.hiresAndAttritionObj?.recentGrowth?.currentYearCount || 0,
      recentAttrition: this.hiresAndAttritionObj?.recentAttrtion?.currentYearCount || 0,
      recentGrowthPercent: this.hiresAndAttritionObj?.recentGrowth?.increaseRate || 0,
      isGrowthRatePositive: this.hiresAndAttritionObj?.recentGrowth?.increaseRate > 0,
      recentAttritionPercent: this.hiresAndAttritionObj?.recentAttrtion?.increaseRate || 0,
      isAttritionRatePositive: this.hiresAndAttritionObj?.recentAttrtion?.increaseRate > 0,
      chartdetails: this.dataSourceWorkCountry?.length ? [{ type: 'google', data: this.dataSourceWorkCountry }] : [],
      medianTenure: GlobalService.convertNumberToYearsAndMonths(this.medianTanuresCount),
      toplocations: this.topLocations.slice(0, 5),
      winningtalentfromcompany: this.companiesGaining.slice(0, 5),
      losingtalenttocompany: this.companiesLosing.slice(0, 5),
      school: this.school.slice(0, 5),
      fieldofstudy: this.fieldOfStudy.slice(0, 5),
      skills: this.skills.slice(0, 5),
      titles: this.titles.slice(0, 5),
      jobDemandCount: this.jobDemandCount != 0 ? this.jobDemandCount : '—'
    }
    this.companyInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getCombinedAggregates() {
    this.jobPostsLoader = true;
    const request = this.aggService.getRequestWithFilters();
    request.aggregatetype = "jobs_base_aggregates";
    request.aggregatescount = 50;
    request.companyids = [this.companyDetails.id];
    this.personSearchService.getTotalAggs(request).subscribe(response => {
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      if (this.combinedSkills?.length > 0 || this.combinedJobtitle?.length > 0 || this.combinedLocation?.length > 0) {
        this.getJobDemandCount();
      } else {
        this.jobPostsLoader = false;
        this.jobDemandCount = 0;
      }
    });
  }

  getJobDemandCount() {
    this.jobPostsLoader = true;
    this.companyaiSuggestions = this.localStorageService.getItem('companyaiSuggestions');
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.companyaiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills));
    const jobtitles = _.uniq(this.companyaiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      startindex: 0,
      resultsize: 10,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations.concat(aggReq?.job_description_keys?.locations || []) || [],
       industries: aggReq?.industries.concat(aggReq?.job_description_keys?.industries || []) || [],
       companies: aggReq?.companies || [],
       functions: aggReq?.functions || [],
       seniority: aggReq?.seniority || [],
       excluded_jobtitles: aggReq?.exclude_jobtitles || [],
       excluded_locations: aggReq?.exclude_locations || [],
       excluded_companies: aggReq?.exclude_companies || [],
       excluded_industries: aggReq?.exclude_industries || [],
       distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
       distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
       aggregatescount: 50,
      companyids: [this.companyDetails.id],
      excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
     }
        this.sliderPayload = payload


    this.talentInsightsService.getJobDemandCount(payload).subscribe(response => {
      this.jobPostsLoader = false;
      if (response && response.status === 'success') {
        this.jobDemandCount = response.data.totalresultscount;
      }
    })
  }

  openJoblistSlider(){
      this.sendDataToSliderSubject.next(this.sliderPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
    }

  /**
   * Section that needs to show in recent hire and attrition matrix
   * @param type
   * @param element
   */
  showAttritionAndHiringElements(type, element) {
    if (type == 'recentGrowth') {
      const isAnyCountPresent = (this.hiresAndAttritionObj.recentGrowth.currentYearCount || this.hiresAndAttritionObj.recentGrowth.increaseRate || this.hiresAndAttritionObj.recentGrowth.previousYearCount);
      if (element == 'currentYearCount') {
        return isAnyCountPresent
      } else if (element == 'increaseRate') {
        return isAnyCountPresent
      } else if (element == 'dash') {
        return !isAnyCountPresent
      }
    } else if (type == 'recentAttrtion') {
      const isAnyCountPresent = (this.hiresAndAttritionObj.recentAttrtion.currentYearCount || this.hiresAndAttritionObj.recentAttrtion.increaseRate || this.hiresAndAttritionObj.recentAttrtion.previousYearCount);
      if (element == 'currentYearCount') {
        return isAnyCountPresent
      } else if (element == 'increaseRate') {
        return isAnyCountPresent
      } else if (element == 'dash') {
        return !isAnyCountPresent
      }
    }
  }

  getJobtitleSkillSuggestions() {
    const aggReq = this.aggService.getRequestWithFilters();
    if ((aggReq?.preferredskills?.length > 0 || aggReq?.jobtitles?.length > 0) || (aggReq?.booleanquery != '*') || aggReq?.pastjobtitles?.length > 0) {
      const payload = {
        skills: aggReq.preferredskills,
        jobtitles: aggReq?.jobtitles,
        boolean: aggReq.booleanquery == "*" ? null : aggReq.booleanquery
      }

      this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe(async (res: any) => {
        const responseData = res.data;
        const titles = [...(responseData.suggestedjobtitles || [])];
        const skills = [...(responseData.suggestedskills || [])];
        const filterSuggestions = {
          jobtitles: titles,
          skills: skills
        }
        this.localStorageService.setItem('companyaiSuggestions', filterSuggestions);
        this.fetchPageData();


      })
    } else {
      this.localStorageService.setItem('companyaiSuggestions', null);
      this.fetchPageData();
    }
  }
}
